import { render } from "./AttendiesForm.vue?vue&type=template&id=069cbe62&scoped=true"
import script from "./AttendiesForm.vue?vue&type=script&lang=js"
export * from "./AttendiesForm.vue?vue&type=script&lang=js"

import "./AttendiesForm.vue?vue&type=style&index=0&id=069cbe62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-069cbe62"

export default script